import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectMinersLoaded } from './miner.selectors';
import { fetchAllMinersThunk } from './miner.thunks';

// The /tenant composite no longer ships every device (see GET tenant/devices). Pages that
// genuinely need the whole fleet in memory — location/pool/contract rollups, the owner and
// task pickers, the dashboard split — call this to page it in once per session. The All
// Devices table does NOT use this; it is server-paged.
export const useEnsureAllMiners = () => {
  const dispatch = useDispatch();
  const loaded = useSelector(selectMinersLoaded);

  useEffect(() => {
    if (!loaded) {
      dispatch(fetchAllMinersThunk());
    }
  }, [dispatch, loaded]);

  return loaded;
};
